'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _has = require('unmutable/lib/has');

var _has2 = _interopRequireDefault(_has);

var _identity = require('unmutable/lib/identity');

var _identity2 = _interopRequireDefault(_identity);

var _merge = require('unmutable/lib/merge');

var _merge2 = _interopRequireDefault(_merge);

var _set = require('unmutable/lib/set');

var _set2 = _interopRequireDefault(_set);

var _update = require('unmutable/lib/update');

var _update2 = _interopRequireDefault(_update);

var _pipeWith = require('unmutable/lib/util/pipeWith');

var _pipeWith2 = _interopRequireDefault(_pipeWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (input) {
    return function (parcelData) {
        return (0, _pipeWith2.default)(parcelData, (0, _has2.default)('value')(input) ? (0, _set2.default)('value', input.value) : (0, _identity2.default)(), (0, _has2.default)('meta')(input) ? (0, _update2.default)('meta', (0, _merge2.default)(input.meta)) : (0, _identity2.default)());
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/parcelData/setSelf.js
// module id = 753
// module chunks = 35783957827783